export const formatDate = (inputDate) => {
  const year = inputDate.slice(0, 4);
  const month = inputDate.slice(4, 6);
  const day = inputDate.slice(6, 8);

  //console.log(`${day}/${month}/${year}`)

  return `${day}/${month}/${year}`;
};
